import { render } from "./DropdownAuth.vue?vue&type=template&id=2b34878c"
import script from "./DropdownAuth.vue?vue&type=script&lang=js"
export * from "./DropdownAuth.vue?vue&type=script&lang=js"

import exportComponent from "D:\\laragon\\www\\leader-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__